export const vueRoutes = Object.freeze({
  login: { name: 'login' },
  users: { name: 'users' },
  notaries: { name: 'notaries' },
  notaryRequests: { name: 'notary-requests' },
  walletRecovery: { name: 'wallet-recovery' },
  rentalsAdmin: { name: 'rentals-admin' },
  topupAdmin: { name: 'topup-admin' },
  usersDetails: { name: 'users-details' },
  realEstate: { name: 'real-estate' },
  commissionedRE: { name: 'commissioned' },
  uncommissionedRE: { name: 'uncommissioned' },
  realEstateDetails: { name: 'real-estate-details' },
  contracts: { name: 'contracts' },
  contractsSell: { name: 'contracts-sell' },
  contractsDerivative: { name: 'contracts-derivative' },
  contractsOverdraft: { name: 'contracts-overdraft' },
  contractsVesting: { name: 'contracts-vesting' },
  contractsAffiliate: { name: 'contracts-affiliate' },
  contractsDetails: { name: 'contacts-details' },
  contractsDetailsOverdraft: { name: 'contracts-details-overdraft' },
  contractsDetailsVesting: { name: 'contracts-details-vesting' },
  dashboard: { name: 'dashboard' },
  operationalAccounts: { name: 'operational-accounts' },
  pooledAccounts: { name: 'pooled-accounts' },
  exchangeRates: { name: 'exchange-rates' },
  personalWallet: { name: 'personal-wallet' },
  wallet: { name: 'wallet' },
  mainAccount: { name: 'main-account' },
  tokenReAccount: { name: 'token-re-account' },
  commissionAccount: { name: 'commission-account' },
  profitAccount: { name: 'profit-account' },
  taxAccount: { name: 'tax-account' },
  approvals: { name: 'approvals' },
  approvalsUsers: { name: 'approvals-users' },
  approvalsNotaries: { name: 'approvals-notaries' },
  approvalsEdit: { name: 'approvals-edit' },
  approvalsTokenization: { name: 'approvals-tokenization' },
  approvalsDigitalTwin: { name: 'approvals-digital-twin' },
  approvalsOffers: { name: 'approvals-offers' },
  approvalsCommissioned: { name: 'approvals-commissioned' },
  approvalsWithdrawal: { name: 'approvals-withdrawal' },
  approvalsOverdrafts: { name: 'approvals-overdrafts' },
  approvalsDeposit: { name: 'approvals-deposit' },
  approvalsWithdrawUSD: { name: 'approvals-withdraw-usd' },
  approvalsVesting: { name: 'approvals-vesting' },
  approvalsAddressModeration: { name: 'approvals-address-moderation' },
  coordination: { name: 'coordination' },
  daoAdmin: { name: 'dao-admin' },
  exchangeAdmin: { name: 'exchange-admin' },
});
